import { render, staticRenderFns } from "./MainCopy.vue?vue&type=template&id=aa97f410&"
import script from "./MainCopy.vue?vue&type=script&lang=js&"
export * from "./MainCopy.vue?vue&type=script&lang=js&"
import style0 from "./MainCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports